import React, { PropsWithChildren } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface DefaultProps {}

export const Default: React.FunctionComponent<
  PropsWithChildren<DefaultProps>
> = (props: PropsWithChildren<DefaultProps>) => {
  return <>{props.children}</>;
};
